module.exports = __webpack_public_path__ + "google-plus.webp?a85904036a51c67065f2e67ba27e4986";